import { useRef } from 'react';

import { getBentoStreamEndpoint } from 'bento-ordering/base/constants/endpoints';
import { createAxios } from 'bento-ordering/base/utils/apiHelpers';
import SubscribableWebSocket from 'hooks/useBentoStream/utils/SubscribableWebSocket';
import useWebSocketErrorHandler from 'hooks/useBentoStream/hooks/useWebSocketErrorHandler';
import { logWarn } from 'logging';

export const _getRoomAccess = async cartSlug => {
  try {
    const axiosInstance = createAxios();
    const response = await axiosInstance({
      method: 'GET',
      url: getBentoStreamEndpoint(cartSlug)
    });

    const { accessToken, websocketUrl } = response.data;
    return { accessToken, websocketUrl };
  } catch (error) {
    const { response: { status, data } = {} } = error;
    const details = { status, data };

    logWarn(
      `BentoStream - could not connect to room ${cartSlug}`,
      JSON.stringify(details)
    );

    throw error;
  }
};

const useWebSocket = () => {
  const subscribersRef = useRef({});
  const webSocketErrorHandler = useWebSocketErrorHandler();

  const connectToRoom = async cartSlug => {
    const subscribableWebSocket = SubscribableWebSocket(
      () => _getRoomAccess(cartSlug),
      subscribersRef,
      webSocketErrorHandler
    );
    await subscribableWebSocket.connect();
    return subscribableWebSocket;
  };

  return { connectToRoom };
};

export default useWebSocket;
